import React from "react";
import Box from '@material-ui/core/Box';

function Banner({children}) {
  return (
    <Box border={1} borderRadius="50%" borderColor="gold">
      <Box border={1} borderRadius="50%" borderColor="black">
        <Box border={1} borderRadius="50%" borderColor="#B3A4C0">
          <Box border={1} borderRadius="50%" borderColor="black">
            <Box border={1} borderRadius="50%" borderColor="#F6F95E">
              <Box border={1} borderRadius="50%" borderColor="black">
                {children}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Banner;
